import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/lab-procedures/autoimmun-lab-procedures/ana";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	ana: {
		id: "form.ana",
		defaultMessage: "ANA"
	},
	value: {
		id: "form.ana.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "text" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ana",
	value: {
		title: messages.ana,
		validator,
		fieldset,
		isImportant: true
	}
};
